<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<div *ngIf="!isPageLoading && isValid" class=" {{themeService.themeCssClass}}">

    <div class=" {{themeService.themeCssClass}}">

        <div fxLayoutAlign="center" fxLayout="row wrap">
            <mat-card class="day-cards green-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Annual Leave
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.totalVacationAllowance}}
                </mat-card-content>
            </mat-card>
            <mat-card class="day-cards red-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Remaining Days
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.remainingVacationAllowance}}
                </mat-card-content>
            </mat-card>
            <mat-card class="day-cards purple-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Days
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.pendingVacationDays}}
                </mat-card-content>
            </mat-card>
            <mat-card class="day-cards amber-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Requests
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.pendingVacationRequests}}
                </mat-card-content>
            </mat-card>
            <mat-card class="day-cards blue-card"><br/>
                <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Carryover
                </mat-card-subtitle>
                <mat-card-content fxLayoutAlign="center" class="day-card-content">
                    {{this.carryover}}
                </mat-card-content>
            </mat-card>
        </div>
        <br/>
        <div fxLayoutAlign="center" fxLayout="row wrap">
            <mat-form-field appearance="outline">
                <mat-label>Year</mat-label>
                <mat-select #selectedValue [value]="placeholderYear"
                            (selectionChange)="displayDataOnTable(selectedValue.value)">
                    <mat-option *ngFor="let year of filterYears" [value]="year">
                        {{year}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutAlign="center">
            <div class="overlay" *ngIf="isRefresh">
                <div class="center">
                    <mat-spinner class="mat-progress-spinner" color="accent"
                                 mode="indeterminate">
                    </mat-spinner>
                </div>
            </div>
            <mat-table [dataSource]="dataSource" matSort matTableFilter #sort>
                <ng-container *ngFor="let field of fieldNames;let i=index" matColumnDef="{{field}}">
                    <th id="headers" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                        class="mat-column-headers-standard">
                        {{displayNames[i]}}
                    </th>
                    <td mat-cell *matCellDef="let vacation" class="mat-column-standard center-text">
                        <div *ngIf="field!='halfDay'&&field!='numberOfAnnualLeaveDays'&&field!='absenceReason'&&field!='dateCreated'&&field!='startDate'&&field!='endDate'&&field!='absenceType'&&field!='requestStatus'">
                            {{ vacation[field] | titlecase }}
                        </div>
                        <div *ngIf="field=='absenceType'">
                            {{ vacation[field] | titlecase | removeUnderscorePipe }}
                        </div>
                        <div *ngIf="field=='requestStatus'">
                            {{ vacation[field] | titlecase | removeUnderscorePipe }}
                        </div>
                        <div *ngIf="field=='halfDay'">
                            {{halfDayStatus(vacation[field])}}
                        </div>
                        <div *ngIf="field=='dateCreated'">
                            {{vacation[field] | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf="field=='startDate' && this.isDate==true">
                            {{vacation[field] | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf="field=='startDate' && this.isDate==false">
                            {{'...'}}
                        </div>
                        <div *ngIf="field=='endDate' && this.isDate==true">
                            {{vacation[field] | date: 'dd/MM/yyyy'}}
                        </div>
                        <div *ngIf="field=='endDate' && this.isDate==false">
                            {{'...'}}
                        </div>
                        <div *ngIf="field=='numberOfAnnualLeaveDays' || field=='absenceReason' && vacation['absenceReason'].length <= 25">
                            {{vacation[field]}}
                        </div>
                        <div *ngIf="field=='absenceReason' && vacation['absenceReason'].length > 25"
                             matTooltip="{{vacation[field]}}"
                             matTooltipPosition="left">
                            {{vacation[field].slice(0, 25) + '...'}}
                        </div>
                        <div *ngIf="field=='modify'&&vacation['requestStatus']=='PENDING'">
                            <button id="modify" (click)="openModifyPopup(employee, vacation)"
                                    class="close-button-right">Edit
                            </button>
                        </div>
                        <div *ngIf="field=='cancel'&&vacation['requestStatus']!='CANCELLED'&&vacation['requestStatus']!='DELETED'&&vacation['requestStatus']!='APPROVED'&&vacation['requestStatus']!='DECLINED'&&vacation['requestStatus']!='CANCEL_REQUEST'">
                            <button id="cancel" (click)="openCancelPopup(vacation.id)" class="close-button-right">
                                Cancel
                            </button>
                        </div>
                        <div *ngIf="field=='cancel'&&vacation['requestStatus']!='CANCELLED'&&vacation['requestStatus']!='DELETED'&&vacation['requestStatus']!='DECLINED'
                            &&vacation['requestStatus']!='PENDING'&&vacation['requestStatus']!='CANCEL_REQUEST'">
                            <button id="requestCancel" (click)="openRequestCancelPopup(vacation)" class="close-button-right">
                                Request Cancel
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="fieldNames; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNames;"
                    [ngClass]="{blueBackground : even}"></tr>
            </mat-table>
        </div>

        <div fxLayoutAlign="center" fxLayout="row wrap">
            <mat-paginator [pageSize]="5"
                           [pageSizeOptions]="[5, 10, 25, 50]"
                           showFirstLastButtons
                           class="blue">
            </mat-paginator>
        </div>

        <div fxLayoutAlign="center" fxLayout="row wrap">
            <button class="buttons" *ngIf="!isExcelExporting" mat-raised-button color="primary" type="button"
                    (click)="exportExcel()">
                Export Excel
            </button>
            <button class="buttons" mat-raised-button color="primary" type="button"
                    (click)="openPersonalPopup(employee)">
                Request Absence
            </button>
        </div>

        <div *ngIf="employee.region=='IRL'">
            <div fxLayoutAlign="center" fxLayout="row wrap">
                <footer fxLayoutAlign="center" fxLayout="row wrap" class="footer">
                    <p>Note: Leave taken during public holidays will not be deducted from your total annual leave
                        entitlement. Please refer to the
                        <a class="bold" target="_blank" rel="noopener noreferrer"
                           href="https://socrates.gm.com/content/dam/socrates/documents/irl/Documents/2025-Ireland-Vacation-and-Holiday-Dates.pdf">Holiday
                            Calendar</a>
                        for a list of upcoming holidays.</p>
                    <p><a class="bold" target="_blank" rel="noopener noreferrer"
                          href="https://socrates.gm.com/content/dam/socrates/documents/irl/Documents/Employee-Handbook-General-Motors-IT-Services-Ireland-Limited_V19_October-2022.pdf">
                        &nbsp;Find your Employee Handbook here</a></p>
                </footer>
            </div>
        </div>

        <div *ngIf="employee.region=='GBR'">
            <div fxLayoutAlign="center" fxLayout="row wrap">
                <footer fxLayoutAlign="center" fxLayout="row wrap" class="footer">
                    <p>Note: Leave taken during public holidays will not be deducted from your total annual leave
                        entitlement. Please refer to the
                        <a class="bold" target="_blank" rel="noopener noreferrer"
                           href="https://socrates.gm.com/content/dam/socrates/documents/gbr/documents/GM%20UK%20Employee%20Handbook_V4.pdf">Holiday
                            Calendar</a>
                        for a list of upcoming holidays.</p>
                    <p><a class="bold" target="_blank" rel="noopener noreferrer"
                          href="https://socrates.gm.com/content/dam/socrates/documents/gbr/documents/GM%20UK%20Employee%20Handbook_V4.pdf">
                        &nbsp;Find your Employee Handbook here</a></p>
                </footer>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!isValid">
    <p class="invalid-user">As an employee you are not onboarded onto the system.</p>
    <p class="invalid-user">If you need to log your vacations via the vacation tracker,</p>
    <p class="invalid-user">Please contact HR or your manager for further assistance</p>
</div>
